import { PageBackgroundField } from "@/components/cms/theme/PageBackgroundField";
import { useGetCmsTheme } from "@/api/cms";
import {
  useCmsThemeEditorOnColorsChange,
  useCmsThemeEditorPalette,
} from "@/context/cms/CmsThemeEditorContext";
import { useCmsPageThemeForm } from "@/hooks/use-cms-page-theme-form";

type Props = {
  formPrefix?: string;
};

export function CmsPageBackgroundField({ formPrefix }: Props) {
  const palette = useCmsThemeEditorPalette();
  const onColorsChange = useCmsThemeEditorOnColorsChange();
  const { data: theme } = useGetCmsTheme();
  const { pageBackgroundColorId, setPageTheme } = useCmsPageThemeForm(formPrefix);

  const defaultHex = theme?.defaultPageBackgroundColor ?? "#FFFFFF";
  const defaultName =
    theme?.colors.find((c) => c.id === theme.defaultPageBackgroundColorId)
      ?.name ?? undefined;

  return (
    <PageBackgroundField
      colors={palette}
      pageBackgroundColorId={pageBackgroundColorId}
      defaultPageBackgroundHex={defaultHex}
      defaultPageBackgroundName={defaultName}
      onChange={(id) => setPageTheme({ pageBackgroundColorId: id })}
      onColorsChange={onColorsChange}
    />
  );
}
